import type { Option } from '@/modules/common/types/option.type.ts';
import { DefaultRouteType, RouteType } from '@/modules/common/enums/route-type.ts';
import { TypeCode } from '@/modules/common/enums/type-code.ts';

export default class DocumentTypeOption implements Option<number> {
  static TYPE_DOCUMENT = new DocumentTypeOption(false, TypeCode.Document, 'document.title');

  private constructor(
    public readonly fromApi: boolean,
    public readonly code: number,
    public readonly label: string,
    public readonly disabled = false,
    public readonly defaultRouteType: RouteType = RouteType.Standard,
    public readonly defaultRouteId: number | null = null,
    public readonly defaultProjectId: number | null = null,
    public readonly mask: string | null = null,
    public readonly docIds: number[] = [],
    public readonly linkTypesIds: number[] = [],
    public readonly projectIds: number[] = [],
    public readonly autoNumbering: boolean = false,
    public readonly numbering: number = -1,
    public readonly template: string | null = null
  ) {}

  static createByResponse(response: any) {
    return new DocumentTypeOption(
      true,
      response.DT_ID,
      response.DT_ID === TypeCode.Document ? 'document.title' : response.Название,
      response.Активен !== 1,
      DocumentTypeOption.getDefaultRouteType(response.DOC_ID_default ?? null),
      DocumentTypeOption.getDefaultRouteId(response.DOC_ID_default ?? null),
      response.P_ID_default || undefined,
      response.Маска,
      response.DOC_IDS ?? [],
      response.LT_IDS ?? [],
      response.P_IDS ?? [],
      Boolean(response.Автонумерация),
      response.Нумерация ?? -1,
      response.Шаблон ?? null
    );
  }

  private static getDefaultRouteId(id: number | null) {
    return id !== DefaultRouteType.None && id !== DefaultRouteType.New ? id : undefined;
  }

  private static getDefaultRouteType(id: number | null) {
    switch (id) {
      case DefaultRouteType.None:
        return RouteType.None;
      case DefaultRouteType.New:
        return RouteType.New;
      default:
        return RouteType.Standard;
    }
  }
}
